module.exports = __webpack_public_path__ + "static/img/header-theme-dark.e796938e.svg";